import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { TrackersFilterListResponse } from '@modules/creatives-link/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import {
  CREATIVES_LINK_PERMISSIONS,
  LOAD_TRACKERS_FILTER_API_URL,
  LOAD_TRACKERS_FILTER_QUERY_KEY,
} from '@modules/creatives-link/constants';

export default function useTrackersFilterListQuery(
  merchant: Ref<number | undefined>,
  dealTypeRef: Ref<string | undefined>,
): IContextQueryResult<TrackersFilterListResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery<TrackersFilterListResponse>({
    queryKey: [LOAD_TRACKERS_FILTER_QUERY_KEY, merchant, dealTypeRef],
    queryFn: ({ signal }) => fetchGet<TrackersFilterListResponse>(
      LOAD_TRACKERS_FILTER_API_URL,
      {
        signal,
        permission: CREATIVES_LINK_PERMISSIONS.SHOW,
        queryParams: {
          merchant: merchant.value,
          condition_type_of_transaction: dealTypeRef.value,
        },
      },
    ),
    gcTime: 0,
    enabled: computed(() => !!dealTypeRef.value && !!merchant.value),
  });
}
